import * as z from "zod";

/**
 * Replaces `before` in the supervisor guidelines. It goes live unless the
 * Playbook draft has its own supervisor edits, in which case only the draft changes.
 */
export const applyShopperAgentSupervisorGuidanceChange = {
  name: "applyShopperAgentSupervisorGuidanceChange" as const,
  input: z.object({ before: z.string().min(1), after: z.string() }),
  output: z.object({ published: z.boolean() }),
};
